import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AdminAuthProvider } from './contexts/AdminAuthContext';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminProfile from './pages/AdminProfile';
import AdminManagement from './pages/AdminManagement';
import UserManagement from './pages/UserManagementEnhanced';
import UserAnalytics from './pages/UserAnalytics';
import SessionManagement from './pages/SessionManagement';
import AuditLogs from './pages/AuditLogs';
import SystemHealth from './pages/SystemHealth';
import DeviceManagement from './pages/DeviceManagement';
import ConnectionNodes from './pages/ConnectionNodes';
import EmailQueue from './pages/EmailQueue';
import EmailAnalytics from './pages/EmailAnalytics';
import AdminLayout from './components/AdminLayout';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AdminAuthProvider>
        <Router>
          <div className="min-h-screen bg-gray-50">
            <Routes>
              <Route path="/login" element={<AdminLogin />} />
              <Route path="/admin" element={
                <ProtectedRoute>
                  <AdminLayout>
                    <AdminDashboard />
                  </AdminLayout>
                </ProtectedRoute>
              } />
              <Route path="/admin/user-analytics" element={
                <ProtectedRoute>
                  <AdminLayout>
                    <UserAnalytics />
                  </AdminLayout>
                </ProtectedRoute>
              } />
              <Route path="/admin/users" element={
                <ProtectedRoute>
                  <AdminLayout>
                    <UserManagement />
                  </AdminLayout>
                </ProtectedRoute>
              } />
              <Route path="/admin/sessions" element={
                <ProtectedRoute>
                  <AdminLayout>
                    <SessionManagement />
                  </AdminLayout>
                </ProtectedRoute>
              } />
              <Route path="/admin/logs" element={
                <ProtectedRoute>
                  <AdminLayout>
                    <AuditLogs />
                  </AdminLayout>
                </ProtectedRoute>
              } />
              <Route path="/admin/system" element={
                <ProtectedRoute>
                  <AdminLayout>
                    <SystemHealth />
                  </AdminLayout>
                </ProtectedRoute>
              } />
              <Route path="/admin/devices" element={
                <ProtectedRoute>
                  <AdminLayout>
                    <DeviceManagement />
                  </AdminLayout>
                </ProtectedRoute>
              } />
              <Route path="/admin/connection-nodes" element={
                <ProtectedRoute>
                  <AdminLayout>
                    <ConnectionNodes />
                  </AdminLayout>
                </ProtectedRoute>
              } />
              <Route path="/admin/email-queue" element={
                <ProtectedRoute>
                  <AdminLayout>
                    <EmailQueue />
                  </AdminLayout>
                </ProtectedRoute>
              } />
              <Route path="/admin/email-analytics" element={
                <ProtectedRoute>
                  <AdminLayout>
                    <EmailAnalytics />
                  </AdminLayout>
                </ProtectedRoute>
              } />
              <Route path="/admin/profile" element={
                <ProtectedRoute>
                  <AdminLayout>
                    <AdminProfile />
                  </AdminLayout>
                </ProtectedRoute>
              } />
              <Route path="/admin/admins" element={
                <ProtectedRoute>
                  <AdminLayout>
                    <AdminManagement />
                  </AdminLayout>
                </ProtectedRoute>
              } />
              <Route path="/" element={<Navigate to="/admin" replace />} />
            </Routes>
          </div>
        </Router>
      </AdminAuthProvider>
    </QueryClientProvider>
  );
}

export default App;